import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { AsyncLoaderControl } from "@/Common/Components/Loader/AsyncLoaderControl";
import * as LocalOperations from "@/Common/Operations/operations.local";

export function ExternalSignIn(): JSX.Element {
    const [loading, setLoading] = useState<boolean>(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (typeof globalThis !== "undefined") {
            const params = new URLSearchParams(globalThis.location.search);
            const apiKey = params.get("apiKey");
            const sessionId = params.get("sessionId");

            if (!apiKey || !sessionId) {
                navigate("?error=missing-credentials", { replace: true });
                return;
            }

            sessionStorage.setItem("apiKey", apiKey);
            sessionStorage.setItem("sessionId", sessionId);

            const decodedApiKey = decodeURIComponent(apiKey);
            apiSettings.setSession(decodedApiKey, sessionId, "external-login");

            const onChange = (): void => {
                const loginModel = sessionStore.clientLoginModel;

                if (!loginModel) return;

                const storedProvinces = sessionStorage.getItem("ClinicActiveProvinces");
                if (storedProvinces && !sessionStore.ClinicActiveProvinces) {
                    sessionStore.ClinicActiveProvinces = JSON.parse(storedProvinces);
                }

                const isLoggedIn = loginModel.get("LoggedIn");
                const isCacheLoaded = loginModel.get("IsCacheLoaded");
                const hasClinicProvinces = sessionStore.ClinicActiveProvinces?.length > 0;

                if (isLoggedIn && sessionStore.loginWorkflow && isCacheLoaded && hasClinicProvinces) {
                    setLoading(false);
                    navigate("/calendar", { replace: true });
                }
            };

            const eventId = sessionStore.AddChangeListener(onChange, this, "ExternalSignIn");

            sessionStore.dispatch(LocalOperations.Login.AuthenticationModuleGetAccessInfo);

            return () => {
                sessionStore.RemoveChangeListener(eventId);
            };
        }
    }, [navigate]);

    return (
        <div data-cy="identifierLoginPlaceholder" className="global-container">
            <AsyncLoaderControl IsActive={loading} />
        </div>
    );
}
